import React from 'react';
import useAnalytics from 'helpers/useAnalytics';
import makeStyles from '@material-ui/core/styles/makeStyles';
import SupportCard from 'components/onboarding/SupportCard';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

interface Props {
  isTrial: boolean;
}

function HelpCard({ isTrial }: Props) {
  const classes = useStyles();
  const analytics = useAnalytics();

  const cardTitle = isTrial ? 'Need Help With Your Trial?' : 'Having Trouble?';
  const cardContent = isTrial
    ? 'Do you need assistance with setting up your free trial? We’re here to help!'
    : 'Having trouble with something you see here? We would love to speak with you and offer any additional support needed.';
  const cardButton = isTrial ? 'Send a Message' : 'Send an Email';

  const handleSupportEmail = () => {
    analytics.track('Having Trouble Support Button clicked', {
      category: 'AD - Home',
      label: 'Send an Email',
    });
  };

  const handleSupportChat = () => {
    analytics.track('Having Trouble Button clicked', {
      category: 'AD - Home',
      label: 'Start a Chat',
    });
  };

  return (
    <SupportCard title={cardTitle}>
      <Typography className={classes.p}>{cardContent}</Typography>
      <Typography className={classes.p}>
        Feel free to send us a message or, use our chat feature to speak to someone immediately.
      </Typography>
      <div className={classes.buttonContainer}>
        <Button
          variant="contained"
          color="secondary"
          href="mailto:support@justsift.com"
          onClick={handleSupportEmail}
        >
          {cardButton}
        </Button>
        <Button
          variant="contained"
          color="secondary"
          href="mailto:support@justsift.com"
          className="intercom-chat"
          onClick={handleSupportChat}
        >
          Start a chat
        </Button>
      </div>
    </SupportCard>
  );
}

const useStyles = makeStyles(theme => ({
  root: {},
  p: {
    marginBottom: theme.spacing(3),
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-evenly',
    marginTop: theme.spacing(4.5),
  },
}));

export default HelpCard;
